<template>
  <v-select
    v-model="selectedBrand"
    :items="allBrands"
    :rules="rules"
    :disabled="disabled"
    :loading="isLoading"
    multiple
    label="Brand"
  ></v-select>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';

export default {
  props: {
    brandValue: {
      type: Array,
      default: () => [0]
    },
    rules: {
      type: Array,
      default: () => []
    },
    hasAllOption: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    allBrands() {
      let brands = this.$store.state.brands.brands.map(x => {
        return { text: x.description, value: x.id };
      });
      if (this.hasAllOption) {
        brands.unshift({ text: 'All', value: 0 });
      }
      return brands;
    },
    selectedBrand: {
      get: function() {
        return this.brandValue;
      },
      set: function(newValue) {
        if (newValue.includes(0) && !this.brandValue.includes(0)) {
          newValue = [0];
        } else if (
          this.brandValue.length === 1 &&
          this.brandValue.includes(0) &&
          newValue.length > 1
        ) {
          newValue.splice(0, 1);
        }
        this.$emit('input', newValue);
      }
    }
  },
  created() {
    this.isLoading = true;
    this.getBrands()
      .then(() => {
        this.isLoading = false;
      })
      .catch(error => {
        this.isLoading = false;
        this.showSnackbar({ text: error, color: 'error', timeout: 3000 });
      });
  },
  methods: {
    ...mapMutations('snackbar', ['showSnackbar']),
    ...mapActions('brands', ['getBrands'])
  }
};
</script>

<style></style>
